import type { Copy } from "../types";

export const bn: Copy = {
    seo: {
      title: "গাড়ির বয়স ক্যালকুলেটর | বছর ও মাস অনুযায়ী গাড়ির বয়স দেখুন",
      description:
        "উৎপাদনের বছর এবং ঐচ্ছিক মাস থেকে গাড়ির সঠিক বয়স দেখুন। একটি পরিষ্কার টুলে বছর, মাস, দিন, মোট দিন এবং গুরুত্বপূর্ণ মাইলস্টোন দেখুন।",
      keywords: [
        "গাড়ির বয়স ক্যালকুলেটর",
        "যানবাহনের বয়স ক্যালকুলেটর",
        "গাড়ির উৎপাদন বছর দেখুন",
        "গাড়ির উৎপাদন মাস দেখুন",
        "আমার গাড়ি কত পুরনো",
        "বছর অনুযায়ী গাড়ির বয়স",
        "গাড়ির বয়স পরীক্ষা",
        "RC বয়স ক্যালকুলেটর",
        "মাস অনুযায়ী গাড়ির বয়স",
        "যানবাহনের তারিখ ক্যালকুলেটর",
        "mParivahan বিকল্প",
        "Parivahan বিকল্প",
        "RTO যানবাহনের বয়স ক্যালকুলেটর",
        "গাড়ির নিবন্ধন বয়স",
        "যানবাহনের নিবন্ধন বয়স",
      ],
      faq: [
        {
          question: "এই ক্যালকুলেটর কী করে?",
          answer:
            "এটি নির্বাচিত উৎপাদন বছর এবং ঐচ্ছিক মাস থেকে গাড়ির সঠিক বয়স গণনা করে, তারপর বছর, মাস, দিন এবং মাইলস্টোন তথ্য দেখায়।",
        },
        {
          question: "ঐচ্ছিক মাস কেন আছে?",
          answer:
            "মাস যোগ করলে বয়সের হিসাব আরও নির্ভুল হয়। মাস না নিলে নির্বাচিত বছরের জানুয়ারি ব্যবহার করা হয়।",
        },
        {
          question: "ভবিষ্যতের বছর বা মাস কি বেছে নেওয়া যায়?",
          answer:
            "না। ভবিষ্যতের বছর বন্ধ থাকে এবং নির্বাচিত বছর বর্তমান বছর হলে ভবিষ্যতের মাসও অকার্যকর থাকে।",
        },
      ],
    },
    headerTagline: "যানবাহন ইউটিলিটি",
    headerTitle: "গাড়ির বয়স ক্যালকুলেটর",
    reset: "রিসেট",
    switchToLight: "হালকা মোডে যান",
    switchToDark: "গাঢ় মোডে যান",
    languageLabel: "ভাষা",
    languageEnglish: "ইংরেজি",
    languageHindi: "হিন্দি",
    heroEyebrow: "গাড়ির বয়স, পরিষ্কারভাবে",
    heroTitle: "যানবাহনের বয়স জানার জন্য একটি পরিষ্কার তারিখ টুল।",
    heroDescription: "উৎপাদনের বছর বেছে নিন। আরও নির্ভুল ফল চাইলে শুধু মাস যোগ করুন।",
    yearSelectLabel: "উৎপাদনের বছর",
    monthSelectLabel: "উৎপাদনের মাস",
    includeMonthLabel: "আরও নির্ভুলতার জন্য নির্দিষ্ট মাস অন্তর্ভুক্ত করুন",
    includeMonthNote: "মাস না দিলে হিসাবের জন্য জানুয়ারি ধরা হবে।",
    yearOnlyBadge: "শুধু বছর",
    yearMonthBadge: "বছর + মাস",
    yearPlaceholder: "বছর নির্বাচন করুন",
    monthPlaceholder: "মাস নির্বাচন করুন",
    inputTitle: "উৎপাদনের বছর",
    inputLabel: "উৎপাদনের বছর",
    blockedDateNote: "ভবিষ্যতের বছর নির্বাচন করা যাবে না।",
    result: "ফলাফল",
    vehicleAgeLead: "আপনার গাড়ি",
    asOfToday: "আজ পর্যন্ত",
    years: "বছর",
    months: "মাস",
    days: "দিন",
    totalDays: (count) => `মোট ${count.toLocaleString("en-IN")} দিন`,
    ageLabels: { almostNew: "প্রায় নতুন", modern: "আধুনিক", mature: "পরিণত", classic: "ক্লাসিক" },
    estimatedValue: {
      high: "পুনর্বিক্রির সম্ভাবনা বেশি",
      healthy: "মূল্য ধরে রাখে ভালো",
      moderate: "মাঝারি অবচয়",
      collector: "সংগ্রাহকের আগ্রহ বাড়তে পারে",
    },
    maintenanceTitle: "রক্ষণাবেক্ষণ",
    maintenance: {
      routine: "নিয়মিত সার্ভিস এবং OEM যত্ন",
      watch: "ব্রেক, তরল ও টায়ারের দিকে নজর দিন",
      plan: "ক্ষয়প্রাপ্ত অংশ ও পরিদর্শনের পরিকল্পনা করুন",
      specialized: "বিশেষায়িত রক্ষণাবেক্ষণ আরও গুরুত্বপূর্ণ হয়ে ওঠে",
    },
    registrationTitle: "নিবন্ধন",
    registration: {
      collector: "কিছু অঞ্চলে সংগ্রাহক-ধরনের সুবিধা পেতে পারে",
      classic: "কিছু অঞ্চলে ক্লাসিক গাড়ির নিবন্ধন প্রযোজ্য হতে পারে",
      standard: "সাধারণ নবায়ন ও আঞ্চলিক পরীক্ষা আশা করুন",
      regular: "সাধারণ নিবন্ধনই সাধারণত প্রযোজ্য",
    },
    upcomingMilestoneTitle: "পরবর্তী মাইলস্টোন",
    milestoneTimelineTitle: "মাইলস্টোন টাইমলাইন",
    milestoneRemaining: ({ label, days }) => `${label} ${days.toLocaleString("bn-BD")} দিনের মধ্যে`,
    reached: "সম্পন্ন",
    upcoming: "আসন্ন",
    allMilestonesReachedTitle: "তালিকাভুক্ত সব মাইলস্টোন সম্পন্ন হয়েছে",
    allMilestonesReachedBody: "এই যানবাহনটি অ্যাপে প্রদর্শিত মাইলস্টোন সীমা অতিক্রম করেছে।",
    copySummary: "সারাংশ কপি করুন",
    shareResult: "ফলাফল শেয়ার করুন",
    resetMessage: "ক্যালকুলেটর রিসেট করা হয়েছে",
    summaryCopied: "সারাংশ ক্লিপবোর্ডে কপি হয়েছে",
    clipboardFailed: "ক্লিপবোর্ডে প্রবেশ করা যায়নি",
    emptyTitle: "সম্পূর্ণ বিবরণ দেখতে উৎপাদনের বছর বেছে নিন",
    emptyDescription:
      "বছর বেছে নিলে আপনি সঠিক বয়স, মোট দিন, রক্ষণাবেক্ষণ নোট, ক্লাসিক অবস্থা এবং মাইলস্টোনের সময় দেখতে পাবেন।",
    shareTitle: "গাড়ির বয়স ক্যালকুলেটর",
    summary: ({ label, years, months, days, asOf }) =>
      `আমার গাড়ি ${label} সালে তৈরি হয়েছে এবং ${asOf} তারিখে এর বয়স ${years} বছর ${months} মাস ${days} দিন।`,
    milestones: {
      1: { label: "প্রথম বছর", note: "ওয়ারেন্টি এবং সার্ভিস পরিকল্পনার জন্য উপযোগী।" },
      3: { label: "তিন বছর", note: "পুনর্বিক্রি এবং মূল্য পরিবর্তনের সাধারণ সময়।" },
      5: { label: "পাঁচ বছর", note: "রক্ষণাবেক্ষণ বাজেট পুনর্বিবেচনার ভালো সময়।" },
      10: { label: "দশ বছর", note: "পুরনো অংশগুলোর দিকে বেশি নজর দরকার।" },
      15: { label: "পনেরো বছর", note: "অনেক অঞ্চলে ক্লাসিক ধরনের ব্যবহার শুরু হয়।" },
      25: { label: "পঁচিশ বছর", note: "কিছু বাজারে সংগ্রাহক এবং আমদানির জন্য আকর্ষণীয়।" },
    },
  };
